<div class="flex-row top-bar">
  <div class="flex-col filters-col">
    <div class="date-picker">
      <div class="d-flex">
        <label>Datum atelier:</label>
        <mat-datepicker-toggle class="no-ripple" matPrefix [for]="picker">
          <mat-icon
            class="align-calendar-icon calendar-icon-display"
            matDatepickerToggleIcon
            svgIcon="inpress-calendar"
          ></mat-icon>
        </mat-datepicker-toggle>
        <input
          class="date-picker-input"
          matInput
          [readonly]="true"
          [matDatepicker]="picker"
          [ngModel]="filterDate"
          (ngModelChange)="dateChange($event)"
        />
        <mat-datepicker #picker></mat-datepicker>
      </div>
    </div>
    <div class="flex-row">
      <mat-checkbox
        [(ngModel)]="includeUnassigned"
        (ngModelChange)="includeUnassignedChanged()"
      >
        Toon toeren niet toegewezen
      </mat-checkbox>
    </div>
  </div>
  <div class="flex-row groupings-row">
    <div class="flex-col" *ngFor="let grouping of amountsGrouped">
      <label
        ><b>{{ grouping.firstName }} {{ grouping.lastName }}</b></label
      >
      <label
        >Plaatsen : <b>{{ grouping.nbToPlace }}</b></label
      >
      <label
        >Verkocht : <b>{{ grouping.nbSold }}</b></label
      >
      <label
        >Aanpassing : <b>{{ grouping.nbAdjustment }}</b></label
      >
    </div>
  </div>
</div>

<div [ngClass]="loading ? 'lock' : ''">
  <div class="table-container panel">
    <div class="example-table-container">
      <div
        *ngIf="loading"
        class="table-loader-overlay"
        style="margin-top: 55px"
      >
        <div style="margin-top: 145px; align-self: center">
          <mat-spinner
            style="margin: auto"
            color="primary"
            diameter="75"
          ></mat-spinner>
        </div>
      </div>
      <table mat-table [dataSource]="items" class="atelier-table" matSort>
        <ng-container matColumnDef="placer">
          <th mat-header-cell *matHeaderCellDef class="header-text">
            <div class="d-flex">
              <div class="text-middle">
                <b>Installateur</b>
              </div>
            </div>
          </th>
          <td mat-cell *matCellDef="let row" class="table-text">
            {{ row.placer.firstName }}
          </td>
        </ng-container>

        <ng-container matColumnDef="tourDate">
          <th mat-header-cell *matHeaderCellDef class="header-text">
            <div class="d-flex">
              <div class="text-middle">
                <b>Datum toer</b>
              </div>
            </div>
          </th>
          <td mat-cell *matCellDef="let row" class="table-text">
            {{ row.date | date : 'dd/MM/yyyy' }}
          </td>
        </ng-container>

        <ng-container matColumnDef="branch">
          <th mat-header-cell *matHeaderCellDef class="header-text">
            <div class="d-flex">
              <div class="text-middle">
                <b>Filiaal</b>
              </div>
            </div>
          </th>
          <td mat-cell *matCellDef="let row" class="table-text">
            {{ row.branch }}
          </td>
        </ng-container>

        <ng-container matColumnDef="atelierDate">
          <th mat-header-cell *matHeaderCellDef class="header-text">
            <div class="d-flex">
              <div class="text-middle">
                <b>Datum atelier</b>
              </div>
            </div>
          </th>
          <td mat-cell *matCellDef="let row" class="table-text">
            {{ row.atelierDate | date : 'dd/MM/yyyy' }}
          </td>
        </ng-container>

        <ng-container matColumnDef="atelierEmployee">
          <th mat-header-cell *matHeaderCellDef class="header-text">
            <div class="d-flex">
              <div class="text-middle">
                <b>Medewerker</b>
              </div>
            </div>
          </th>
          <td mat-cell *matCellDef="let row" class="table-text">
            {{ row.atelierEmployee?.firstName }}
          </td>
        </ng-container>

        <ng-container matColumnDef="reviewEmployee">
          <th mat-header-cell *matHeaderCellDef class="header-text">
            <div class="d-flex">
              <div class="text-middle">
                <b>Controle</b>
              </div>
            </div>
          </th>
          <td mat-cell *matCellDef="let row" class="table-text">
            {{ row.reviewEmployee?.firstName }}
          </td>
        </ng-container>

        <ng-container matColumnDef="nbToPlace">
          <th mat-header-cell *matHeaderCellDef class="header-text">
            <div class="d-flex">
              <div class="text-middle">
                <b>Te plaatsen</b>
              </div>
            </div>
          </th>
          <td mat-cell *matCellDef="let row" class="table-text">
            {{ row.nbToPlace }}
          </td>
        </ng-container>

        <ng-container matColumnDef="nbSold">
          <th mat-header-cell *matHeaderCellDef class="header-text">
            <div class="d-flex">
              <div class="text-middle">
                <b>Verkocht</b>
              </div>
            </div>
          </th>
          <td mat-cell *matCellDef="let row" class="table-text">
            {{ row.nbSold }}
          </td>
        </ng-container>

        <ng-container matColumnDef="nbAdjustment">
          <th mat-header-cell *matHeaderCellDef class="header-text">
            <div class="d-flex">
              <div class="text-middle">
                <b>Aanpassingen</b>
              </div>
            </div>
          </th>
          <td mat-cell *matCellDef="let row" class="table-text">
            {{ row.nbAdjustment }}
          </td>
        </ng-container>

        <ng-container matColumnDef="route">
          <th mat-header-cell *matHeaderCellDef class="header-text">
            <div class="d-flex">
              <div class="text-middle">
                <b>Route</b>
              </div>
            </div>
          </th>
          <td mat-cell *matCellDef="let row" class="table-text">
            <div>
              <ng-container
                *ngIf="row?.tourChecked; then checked; else unchecked"
              >
              </ng-container>
              <ng-template #checked>
                <div>
                  <span class="rounded-circle route-icon route-checked">
                    V
                  </span>
                </div>
              </ng-template>
              <ng-template #unchecked>
                <div>
                  <span class="rounded-circle route-icon route-unchecked">
                    X
                  </span>
                </div>
              </ng-template>
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="finished">
          <th mat-header-cell *matHeaderCellDef class="header-text">
            <div class="d-flex">
              <div class="text-middle">
                <b>Afgewerkt</b>
              </div>
            </div>
          </th>
          <td mat-cell *matCellDef="let row" class="table-text">
            <div *ngIf="row.atelierFinished" class="dot"></div>
          </td>
        </ng-container>

        <ng-container matColumnDef="reviewed">
          <th mat-header-cell *matHeaderCellDef class="header-text">
            <div class="d-flex">
              <div class="text-middle">
                <b>Controle</b>
              </div>
            </div>
          </th>
          <td mat-cell *matCellDef="let row" class="table-text">
            <div *ngIf="row.atelierReviewed" class="dot"></div>
          </td>
        </ng-container>

        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef class="header-text">
            <div class="d-flex">
              <div class="text-middle">
                <b></b>
              </div>
            </div>
          </th>
          <td mat-cell *matCellDef="let row" class="table-text">
            <immo-studio-assign-modal
              *ngIf="assignOpen && row.id === assignTourId"
              [tour]="row"
              (atelierAssigneeChanged)="atelierAssigneeChanged()"
            >
            </immo-studio-assign-modal>
            <div class="d-flex">
              <div>
                <button
                  (click)="openEmployeeTourEditModal(row)"
                  class="btn btn--edit"
                >
                  Edit
                </button>
              </div>
              <div>
                <button
                  (click)="toggleAssignModal(row)"
                  class="btn btn--assign"
                >
                  <mat-icon class="icon icon--assign">people</mat-icon>
                </button>
              </div>
              <div>
                <button
                  *ngIf="
                    row.atelierEmployee != null || row.reviewEmployee != null
                  "
                  (click)="unassignTour(row)"
                  class="btn btn--unassign"
                >
                  <mat-icon class="icon icon--unassign">close</mat-icon>
                </button>
              </div>
              <div *ngIf="row.atelierEmployee">
                <mat-menu #actionMenu="matMenu" class="table-text">
                  <button
                    mat-menu-item
                    (click)="impersonateUser(row.atelierEmployee)"
                    class="center-text"
                  >
                    Nabootsen
                  </button>
                </mat-menu>
                <div class="action-container pl-2">
                  <mat-icon
                    class="fa-2x clickable"
                    [matMenuTriggerFor]="actionMenu"
                    >more_vert
                  </mat-icon>
                </div>
              </div>
            </div>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>

        <tr
          mat-row
          class="table-row"
          *matRowDef="let row; columns: displayedColumns"
          [class.row--done]="row.atelierFinished && row.atelierReviewed"
          [class.row--to_be_reviewed]="
            row.atelierFinished && !row.atelierReviewed
          "
          [class.row--in_progress]="
            row.atelierInProgress &&
            !row.atelierFinished &&
            !row.atelierReviewed
          "
        ></tr>
      </table>
    </div>

    <div *ngIf="!items || items.length === 0" class="no-result-text">
      <div>Geen resultaten gevonden</div>
    </div>
    <mat-paginator
      [length]="totalItems"
      [pageSizeOptions]="pageSizeOptions"
      [showFirstLastButtons]="true"
      (page)="onPageChange()"
    ></mat-paginator>
  </div>
</div>
